import type { CarStatus } from '../types/CarStatus';

export const isCarUnavailable = (status: CarStatus): boolean => {
  return Boolean(status?.isSold);
};
